export interface PaginationFeed {
  getPage(): number;
  updatePageNumber(page: number): void;
}

import { Injectable, computed, signal } from '@angular/core';

export interface PaginationState {
  page: number;
}

@Injectable()
export class PaginationStore {
  private readonly _state = signal<PaginationState>({ page: 1 });

  readonly page = computed(() => this._state().page);

  setPage(page: number = 1): void {
    if (page === this._state().page) return;
    this._state.update(s => ({ ...s, page }));
  }

  next(): void {
    this.setPage(+this._state().page + 1);
  }

  reset(): void {
    this.setPage(1);
  }
}
